import { render, staticRenderFns } from "./MultilevelMenuLayout.vue?vue&type=template&id=b5932d80"
import script from "./MultilevelMenuLayout.vue?vue&type=script&lang=js"
export * from "./MultilevelMenuLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports